import { useQuery } from 'react-query';

import { TRIAL_SIGNUP_QUERY_KEYS } from '../constants';
import { fetchTrialPanels, type TrialPanelOption } from '../request';

export const useTrialPanelsQuery = () =>
  useQuery<TrialPanelOption[], Error>(
    [TRIAL_SIGNUP_QUERY_KEYS.PANELS],
    ({ signal }) => fetchTrialPanels(signal),
    { staleTime: Infinity }
  );
